import React from 'react';
import { callFlagOptions } from '../../data/mockContactCallInfo';
import type { CallFlag } from '../../data/mockContactCallInfo';
import { flagStyles } from './ContactCallFlag';
interface CallFlagBadgeProps {
  flag: CallFlag;
}

// Read-only version of the contact call flag, for lists and search results
export function CallFlagBadge({
  flag
}: CallFlagBadgeProps) {
  if (flag === 'none') return null;
  const style = flagStyles[flag];
  const Icon = style.icon;
  const label = callFlagOptions.find(option => option.value === flag)?.label;
  return <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full border text-[11px] font-semibold whitespace-nowrap ${style.className}`} data-id="element-1070" data-mp="36sds2asb2xaw">
      <Icon className="w-3 h-3" aria-hidden="true" data-id="element-1071" data-mp="2xqebtkp47x90" />
      {label}
    </span>;
}